import React from "react"
import { isIOS, isAndroid } from "react-device-detect";
import Email from "../shared/email";
const qs = require('query-string');
class Social extends React.Component {
    componentDidMount() {
        const parseFB = (retries = 10) => {
            if (window.FB) {
                window.FB.XFBML.parse();
            } else if (retries > 0) {
                setTimeout(() => parseFB(retries - 1), 500);
            }
        };
        parseFB();
    }

    render() {
        const parsed = qs.parse(window.location.search.substring(1));
        let fromApp = parsed["app"]

        return (
            <div className="container">
                <div className="row">
                    <div className="col-6 col-lg-4 col-md-4 col-sm-4 col-xm-6 ">
                        <Email value="infoonline@laguiamundial.com" />
                    </div>
                    <div className="col-6 col-lg-4 col-md-4 col-sm-4 col-xm-6 text-right">
                        <div className="text-right d-inline-block mt-2">
                            <a className="btn btn-sm text-white" 
                               style={{ backgroundColor: '#1877f2', border: 'none', fontWeight: 'bold', fontSize: '11px', padding: '2px 8px', borderRadius: '3px' }}
                               target="_blank" rel="noopener noreferrer" 
                               href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(process.env.PUBLIC_URL || 'https://laguiamundial.com/')}`}>
                                <i className="fab fa-facebook-f mr-1"></i> Compartir
                            </a>
                        </div>
                    </div>
                    {isIOS == false && !fromApp ? (
                        <div className="col-3 d-none d-sm-block text-right">
                            <a className={""} target="_blank" href="https://play.google.com/store/apps/details?id=com.laguiamundial.ofertas">
                                <img alt="disponible en google play" style={{ height: "40px" }} src={"https://laguiamundial.com/img/disponible-google-play_50.webp"} />
                            </a>
                        </div>
                    ) : ""}
                </div>
            </div>
        );
    }
}

export default Social